import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../shared/LoadingSpinner';
import useAuthRole from '../../hooks/useAuthRole';
import { isAdminRole, isFinanceRole } from '../../constants/membership';

const AdminAccessGuard = ({ adminAccess = false, financeAccess = false, children }) => {
  const location = useLocation();
  const { user, role, loading } = useAuthRole();

  if (loading) {
    return <LoadingSpinner message="Checking admin access..." />;
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (financeAccess && !isFinanceRole(role)) {
    return <Navigate to="/member/dashboard" replace />;
  }

  if (adminAccess && !isAdminRole(role)) {
    return <Navigate to="/member/dashboard" replace />;
  }

  return children;
};

export default AdminAccessGuard;
